<template>
	<div class="container">
		<div class="areaview">		
			<div class="col">
			    <span class="title">总清扫面积(平方米)</span>		
			    <countTo class="content" :startVal='0' :endVal='entity.workArea' :duration='3000'></countTo>
			</div>
		</div>	
	</div>
</template>

<script>
	import {getIndexEntityCustomView} from '../../api/entity.js'
	import countTo from 'vue-count-to'
	
	export default{
		inject: ['executeWorkDetailSwitch'],
		props: {
			selectedEntity:{
				type:String
			}
		},
		watch: {
			selectedEntity:{
				handler(newData) {
					if(newData != null && newData != ""){
						this.entityid = newData
						this.initEntityInfo()
					}
				},
				immediate: true, //最初绑定值的时候也执行函数
				deep: true //监听一个对象的改变
			}
		},
		components: {
		   countTo 
		},
		data(){
			return{
				// username:localStorage.getItem('username'),
				entityid:'',
				entity:{},
			}
		},
		methods:{
			initEntityInfo(){
				let that = this
				getIndexEntityCustomView(that.entityid).then(res =>{
					if(res.result == 0){
						that.entity = res.entityInfo						
					}else{
						this.$message({
							message: '未获取到运营单位运营概况信息',
							type: 'error'
						});		
					}
				})
			},
		}
	}
</script>

<style  lang="scss" scoped>
	.container{
		z-index: 1000;
		position: fixed;
		// width: 50%;
		height: 10%;
		left: 40%;
		color: #fff;
		font-size: 20px;
		text-align: center;
		
	}
	.areaview{
		display: flex;
		flex-direction: row;
		justify-content:left;
		padding-top: 0.5rem;
	}
	
	.col{
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	.row{
		display: flex;
		flex-direction: row;
		justify-content: center;
	}
	
	.title{
		font-size: 16px;
		font-weight: 600;
		color: rgb(3,166,224);
		border-color: rgba(3,166,224, 1);
		letter-spacing: 2px;
	}
	.title::after {
	    content: '';
	    display: block;
	    width: 200px;
	    height: 2px;
	    background: linear-gradient(to right, transparent, rgb(3,166,224), transparent);
	    margin: 8px auto 0;
	}
	.content{
		font-size: 48px;
		font-weight: bold;
		color: rgb(3,166,224);
		letter-spacing: 12px;
	}
	
</style>
